import { ProductTypeConfig, DEFAULT_SECTIONS } from '../types';

/**
 * 1100 - Capital Protection Certificate
 */
export const config1100: ProductTypeConfig = {
  code: '1100',
  name: 'Capital Protection Certificate',
  sections: {
    ...DEFAULT_SECTIONS,
    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      enabled: true,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: false
      },
    },
    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: false,
    },
    coupons: {
      ...DEFAULT_SECTIONS.coupons,
      enabled: false,
    },
    earlyRedemption: {
      ...DEFAULT_SECTIONS.earlyRedemption,
      enabled: false,
    },
  },
};
